import { type YDatabase } from '@databases/collab/y-database';
import { Properties as FieldProperties } from '@databases/collab/y-field';
import * as Y from 'yjs';

/**
 * Pulls out content ID from a nested object into the string property for parent
 * page field setting.
 */
export const parentPageContentId = {
  version: 3,
  apply(documentId: string, ydb: YDatabase) {
    for (const fieldId of ydb.fields) {
      const field = ydb.fieldsById[fieldId];
      const fieldMap = field.unwrap();
      if (fieldMap instanceof Y.Map) {
        const parentPageSetting = fieldMap.get(FieldProperties.settingParentPage);
        if (parentPageSetting && typeof parentPageSetting === 'object') {
          if (
            'contentId' in parentPageSetting &&
            typeof parentPageSetting.contentId === 'string'
          ) {
            field.parentPage = parentPageSetting.contentId;
          }
        }
      }
    }
  },
};
